import { MarkedStatus } from "@/gql/types";

/**
 * Returns the mark filter value for GraphQL.
 * Backend expects MarkedStatus enum: Marked | NotMarked
 */
export const getMarkFilterValue = (
  mark?: MarkedStatus | null
): MarkedStatus | undefined => {
  if (!mark) {
    return undefined;
  }
  return mark;
};
